import React from 'react';
import {observer} from "mobx-react";
import {Alert, Button, Snackbar} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ButtonWithConfirmation from "../../components/button/ButtonWithConfirmation";
import DeleteIcon from "@mui/icons-material/Delete";
import MyMaterialTable from "../../components/mtable/MyMaterialTable";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {companyApi} from "../../backend/CompanyApi";
import {Link} from "react-router-dom";
import {routes} from "../../main/Routes";
import {userInfoStore} from "../../store/UserInfo";
import {SnackbarCloseReason} from "@mui/material/Snackbar/Snackbar";

interface IProps {
}

interface IState {
    showError: boolean,
    errorMessage: string
}

@observer
class CompaniesTable extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showError: false,
            errorMessage: ''
        }
    }

    render() {
        const companies = userInfoStore.companies.map(it => {
            return {...it, index: userInfoStore.companies.indexOf(it) + 1};
        });
        return <>
            <MyMaterialTable
                    title="My companies"
                    columns={[
                        {title: '#', field: 'index', align: "center", width: "5%", editable: 'never'},
                        {
                            title: 'Company Name',
                            field: 'name',
                            validate: rowData => rowData.name === '' ? 'Name cannot be empty' : ''
                        },
                        {
                            title: 'API id',
                            field: 'apiId',
                            validate: rowData => rowData.apiId === '' ? 'API id cannot be empty' : ''
                        },
                        {
                            title: 'API key',
                            field: 'apiKey',
                            validate: rowData => rowData.apiKey === '' ? 'API key cannot be empty' : ''
                        },
                    ]}
                    data={companies}
                    options={{
                        search: true,
                        sorting: false,
                        paging: true,
                        pageSize: 10,
                        draggable: false,
                        actionsColumnIndex: 4,
                        addRowPosition: "first"
                    }}

                    actions={[
                        row => ({
                            icon: () => <Button
                                    variant="contained"
                                    component={Link}
                                    onClick={() => {
                                        selectedCompanyStore.companyId = row.id;
                                    }}
                                    to={routes.companySettings}
                                    startIcon={<EditIcon/>}>Settings</Button>,
                            onClick: (event, rowData) => {
                            }
                        }),
                        row => ({
                            icon: () => <ButtonWithConfirmation variant="contained" color="secondary"
                                                                onClick={this.deleteCompany(row.id)}
                                                                disabled={selectedCompanyStore.companyId === row.id}
                                                                startIcon={<DeleteIcon/>}>
                                Delete
                            </ButtonWithConfirmation>,
                            onClick: () => {
                            }
                        }),
                    ]}

                    editable={{
                        onRowAdd: newData => this.doAddCompany(newData.name, newData.apiId, newData.apiKey),
                    }}
            />
            <Snackbar open={this.state.showError} autoHideDuration={6000} onClose={this.handleClose}>
                <Alert onClose={this.handleClose} severity="error">
                    {this.state.errorMessage}
                </Alert>
            </Snackbar>
        </>;
    }

    private handleClose = (event?: any, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({
            showError: false
        });
    };

    private doAddCompany = async (name: string, apiId: string, apiKey: string) => {
        try {
            await
                    companyApi.addCompany({name, apiId, apiKey});
        } catch (e) {
            this.setState({
                showError: true,
                errorMessage: "Failed to add company!"
            })
            throw e;
        }

        await userInfoStore.refreshCompanies();
    }

    private deleteCompany = (id: string) => async () => {
        try {
            await companyApi.deleteCompany(id);
        } catch (e) {
            this.setState({
                showError: true,
                errorMessage: "Failed to delete company!"
            })
            throw e;
        }
        await userInfoStore.refreshCompanies();
    }
}

export default CompaniesTable;